<template>
  <div>
    <mt-header title="实名认证" style="position:fixed;top:0;width:100%;z-index:1000;">
      <div @click="$router.go(-1)" slot="left">
        <mt-button icon="back"></mt-button>
      </div>
    </mt-header>
    <div>

      <!-- 头像 -->
      <div style="display:flex;margin-top:70px;">
        <div style="margin-left:10px;">证件照片</div>
        <div>
          <div class="photo">
              <img :src="portraitYrl" alt="" style="width:237px;height:150px;" @click="upPortraitBtn('on')" v-if="portraitYrl">
              <div v-else  class="addImg" @click="upPortraitBtn('on')">
                  <van-icon size="50" name="plus" />
                  <p style="margin-top:10px;color:#999;">身份证人像面</p>
              </div>
              <input class="upDataPart" type="file" multiple accept="image/*" ref="upPortrait" id="on" @change="portraitChange($event)"/>
          </div>
          <div class="photo">
              <img :src="portraitYrlOther" alt="" style="width:237px;height:150px;" @click="upPortraitBtn('off')" v-if="portraitYrlOther">
              <div v-else  class="addImg" @click="upPortraitBtn('off')">
                  <van-icon size="50" name="plus" />
                  <p style="margin-top:10px;color:#999;">身份证国徽面</p>
              </div>
              <input class="upDataPart" type="file" multiple accept="image/*" ref="upPortraitOther" id="off" @change="portraitChange($event)"/>
          </div>
        </div>
      </div>
      <!-- 头像剪裁 -->
      <!-- <div class="cut" v-show="portraitShow">
          <div class="cutBtn">
              <mt-button type="primary" size="small" @click="configPart()">完成</mt-button>
              <mt-button type="default" size="small" @click="canclePart()">取消</mt-button>
          </div>
          <vueCropper ref="cropper" :img="portraitUrl" :autoCrop="true" :fixedBox="true" :fixed="option.fixed" :fixedNumber="option.fixedNumber"  :outputSize="0.1"></vueCropper>
      </div> -->
    </div>
    <div class="standard">
      上传单个附件大小限制为4M，图片最小边不小于15px，最长边不超过4096px，格式为JPEG、JPG、PNG、BMP
    </div>
    <div class="next">
      <van-button type="info" @click="save">提交审核</van-button>
    </div>
  </div>
</template>
<script>
import vueCropper from 'vue-cropper'
import { Toast } from 'vant';
export default {
  name:'realName',
  components: {
      vueCropper,
  },
  data(){
    return {
      // 头像
      // 显示隐藏剪裁div
      portraitShow: false,
      // 头像上传的本地路径
      portraitUrl: '',
      // 剪裁后图路径（base64）建议将这个路径和后台取到的反显路径写在一个变量中
      // portraitYrl: 'data:image/png;base64,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',
      portraitYrl:'',
      portraitYrlOther:'',
      portraitYrlFile:'',
      portraitYrlOtherFile:'',
      option:{
          fixedNumber:[1,1],
          fixed:true,
      },
    }
  },
  created(){
    this.$emit('footer', false);
  },
  methods:{
    // 图片上传
    canclePart: function () {
        this.portraitShow = false
    },
    upPortraitBtn: function (gate) {
      // console.log(gate === 'on',gate)
      if(gate === 'on'){
        this.$refs.upPortrait.click()
      }else{
        this.$refs.upPortraitOther.click()
      }
    },
    portraitChange: function (e) {
        let _this = this
        var fil = e.target.files[0]
        // console.log(fil)

        let photoSize = 4194304 //1024*1024*4
        let photoTypeArr = fil.type.split("/")
        let photoType = photoTypeArr[1]

        if(fil.size > photoSize){
          Toast({
            message: '请按照规格要求上传图片',
            forbidClick: true,
          });
        }else{
          if(photoType === 'jpeg' || photoType === 'png' || photoType === 'jpg' || photoType === 'bmp'){
            var reader = new FileReader()
            reader.readAsDataURL(fil)
            reader.onload = function () {
              if(e.target.id === 'on'){
                // console.log(fil)
                _this.portraitYrlFile = fil
                _this.portraitYrl = reader.result
              }else{
                // console.log(fil)
                _this.portraitYrlOtherFile = fil
                _this.portraitYrlOther = reader.result
              }
                // console.log(reader.result)
            }
            // this.portraitShow = true //剪裁
          }else{
            Toast({
              message: '请按照规格要求上传图片',
              forbidClick: true,
            });
          }
        }

    },
    // 提交审核
    save(){
        let _this = this
        if(_this.portraitYrlFile && _this.portraitYrlOtherFile){

          Toast.loading({
            message: '正在审核中',
            forbidClick: true,
            duration:0
          });

          let param = new FormData()
          param.append('idCardPortrait', _this.portraitYrlFile)
          param.append('idCardEmblem', _this.portraitYrlOtherFile)
          param.append('userId',sessionStorage.getItem('loginId'))
          // console.log(param.get("idCardPortrait"))//FormData取值

          _this.axios({
            method: 'post',
            url: '/url/account/certificateIdCard',
            data: param,
            timeout:40000
          }).then(function (res) {
            Toast.clear();//关闭提示框
            if (res.data.success === true) {//上传成功
                 _this.$router.push({path:'/realNameSuccess'})
            } else {
                if(res.data.msg === '认证失败'){
                  _this.$router.push({path:'/realNameFailed'})
                }else{
                  Toast({
                    message: res.data.msg,
                    forbidClick: true,
                  });
                }
            }
          }).catch(function (err) {
            // console.log('请求超时，请稍后查结果')
            Toast.clear();//关闭提示框
            Toast({
              message: '请求超时，请稍后查结果',
              forbidClick: true,
            });
          })
        }else{
          Toast({
            message: '请上传证件照',
            forbidClick: true,
          });
        }
    }

    // 剪裁确定，上传头像
    // configPart: function () {
        // let _this = this
        // _this.$refs.cropper.getCropData((data) => {
        //     _this.portraitYrl = data
        //     _this.portraitShow = false
        //     let param = new FormData()
        //     param.append('img', _this.portraitYrl)

        //     _this.axios({
        //       method: 'post',
        //       url: '/url/user/uploadAvatar',
        //       timeout: 100000,
        //       data: param
        //     }).then(function (response) {
        //       if (response.data.success) {
        //           _this.form.photo = response.data.data.id
        //           console.log('上传成功')
        //       } else {
        //           console.log('上传失败')
        //       }
        //     }).catch(function (response) {
        //       console.log(response)
        //     })
        // })
    // },
    // 剪裁取消
    // canclePart: function () {
        // this.portraitShow = false
    // },
  }
}
</script>
<style scoped>
/* 上传图片 */
.photo{
    padding:0 20px 20px 10px;
    display: flex;
}
.photo p{
    display: inline-block;
    margin-right: 10px;
    font-size:14px;
}
.photo .van-uploader{
    display: inline-block;
}
.addImg{
    width:237px;
    height:150px;
    border: 1px solid #ddd;
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.addImg .van-icon{
    font-size:24px;
    color:#c3bfbf;
}
.addImg p{
    margin-right:0!important;
}
.upDataPart{
  display: none;
}
/* 剪裁 */
.cut{
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 5;
  background-color: #fff;
}
.cut .cutBtn{
  padding: 5px 20px;
}

/* 规范 */
.standard{
  padding: 10px;
  color: #999;
}
/* 按钮 */
.next{
    /* position:fixed; */
    text-align:center;
    bottom:80px;
    background:#fff;
    width:100%;
    padding:10px 0 50px;
}
.next .van-button{
    width:60%;
    height:37px;
    border-radius: 5px;
    color:#fff;
}
</style>



// WEBPACK FOOTER //
// realName.vue?2d47b2fc